var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsistentes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 102.4 88",
    style: {
      enableBackground: "new 0 0 102.4 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_00000039121219491568554110000003261386424749616553_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.7,0C24.2,0,15.6,8.5,15.6,19s8.5,19.1,19,19.1c10.5,0,19.1-8.5,19.1-19c0,0,0,0,0,0 C53.7,8.5,45.2,0,34.7,0z M34.7,30.4c-6.3,0-11.4-5-11.4-11.3c0-6.3,5-11.4,11.3-11.4c6.3,0,11.4,5,11.4,11.3c0,0,0,0,0,0 C46,25.3,40.9,30.4,34.7,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,88c1.3,0,2.4-1.1,2.4-2.4c0-0.1,0-0.1,0-0.2c0-0.6-0.1-1.3-0.1-1.9c0-13.5,11-24.5,24.5-24.5 s24.5,11,24.5,24.5c0,0.6,0,1.3-0.1,1.9C59,86.7,60,87.9,61.4,88h5.5c1.3,0,2.3-1,2.4-2.3c0.1-0.8,0.1-1.5,0.1-2.3 c0-19.2-15.5-34.7-34.7-34.7C15.5,48.8,0,64.3,0,83.5c0,0.8,0,1.5,0.1,2.3C0.2,87,1.2,88,2.5,88H7.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.7,5c-6,0-10.8,4.8-10.8,10.8c0,6,4.8,10.8,10.8,10.8c6,0,10.8-4.8,10.8-10.8c0,0,0,0,0,0 C93.5,9.8,88.7,5,82.7,5C82.7,5,82.7,5,82.7,5z M82.7,20c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2 c0,0,0,0,0,0C86.9,18.1,85,20,82.7,20C82.7,20,82.7,20,82.7,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.4,55c0.8,0,1.4-0.6,1.4-1.4c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0-0.4,0-0.7,0-1.1c0-7.7,5.2-12.9,12.9-12.9 c7.7,0,12.9,5.2,12.9,12.9c0,0.4,0,0.7,0,1.1c-0.1,0.7,0.5,1.4,1.2,1.5h4.2c0.7,0,1.3-0.6,1.4-1.3c0-0.4,0-0.8,0-1.3 c0-10.9-8.8-19.7-19.7-19.7C71.8,32.7,63,41.5,63,52.4c0,0.4,0,0.9,0,1.3c0.1,0.7,0.7,1.3,1.4,1.3H68.4z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsistentes);
export default __webpack_public_path__ + "static/media/Asistentes.4b8e87b50d6937a4949cdb582b591b64.svg";
export { ForwardRef as ReactComponent };